import { render } from "./PatientCreateOphthalmicDiseases.vue?vue&type=template&id=fa5a8130&scoped=true"
import script from "./PatientCreateOphthalmicDiseases.vue?vue&type=script&lang=js"
export * from "./PatientCreateOphthalmicDiseases.vue?vue&type=script&lang=js"

import "./PatientCreateOphthalmicDiseases.vue?vue&type=style&index=0&id=fa5a8130&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa5a8130"]])

export default __exports__